/* eslint-disable import/prefer-default-export */
import { useContext } from 'react';
import { StoreContext } from 'helpers/store';

export const useStore = () => useContext(StoreContext);
